<template>
  <qc-container title="员工管理">
    <page-request ref="table" url="/api/mgr/person/list" :table-header="tableHeader" :expend="expend" :prop="{orgId:orgId}">
      <template #op="scope">
        <b-button v-if="scope.row.status===0" @click="updateStatus([scope.row.id],1)">禁用</b-button>
        <b-button v-if="scope.row.status===1" @click="updateStatus([scope.row.id],0)">启用</b-button>
        <b-button @click="toEdit(scope.row)">编辑</b-button>
        <b-button @click="doDel(scope.row)">删除</b-button>
      </template>
    </page-request>
  </qc-container>

  <edit-person @load="pageReloadData" ref="edit"></edit-person>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";
import EditPerson from "@view/store/op/edit-person.vue";

export default {
  props:{
    orgId:{
      type:String,
    }
  },
  name: "person-list",
  components: {EditPerson, BButton, PageRequest, QcContainer},
  data() {
    return {
      tableHeader: [
        {prop: "nickName", label: "员工名称",width:100},
        {prop: "mobile", label: "手机号码",width:160},
        {prop: "remark", label: "员工岗位",width:160},
        {label: "权限",minWidth:360,renderDraw:(row)=>{
           return this.getPermission(row);
          }},
        {label: "状态",width:100,renderDraw:(row)=>{
            return row.status?"禁用":"正常";
          }},
      ],
      expend: [
        {label: "名称/手机", prop: "userName"},
      ],
      personRoleAll: [
        {name:"门店信息",role:"0"},
        {name:"运营数据",role:"1"},
        {name:"员工管理",role:"2"},
        {name:"客户管理",role:"3"},
        {name:"订单管理",role:"4"},
        {name:"商品管理",role:"5"},
        {name:"订单核销",role:"6"},
        {name:"财务管理",role:"7"},
        {name:"售后处理",role:"8"},
        {name:"故障报修",role:"9"},
        {name:"消息管理",role:"10"},
      ]
    }
  },
  mixins: [tableBase],
  methods: {
    getPermission(row){
      let permission = "";
      let roleList = (row.ext2&&row.ext2.split(",")) || [];
      console.log(roleList,row.ext2);
      this.personRoleAll.forEach(role=>{
        if(roleList.indexOf(role.role)>-1){
          permission += role.name+",";
        }
      })
      return permission;
    },
    updateStatus(ids,status){
      this.msgConfirm("/api/mgr/person/batchUpdateStatus",{ids:ids,status:status,contentType:_CONTENT_TYPE_JSON},()=>{
        this.pageReloadData();
      },`您是否要${status?'禁用':'启用'}所选员工?`)
    },
    doDel(row){
      this.msgConfirm("/api/mgr/person/batchDelete",{ids:[row.id],contentType:_CONTENT_TYPE_JSON},()=>{
        this.pageReloadData();
      });
    },
    toEdit(row){
      this.$refs.edit.open(row);
    },
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
